// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"cdac0eca","850":"16112311","928":"91db64af","972":"0d11e0aa","986":"10328f39"}[chunkId] + ".chunk.css";
};